(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-marquee"] && !Shopify.designMode) return;
  try {
    
(function () {
  const registry = new Map();

  class HmModal {
    constructor(el) {
      this.el = el;
      this.panel = el.querySelector('.hm-modal__panel');
      this.busy = false;

      el.querySelector('.hm-modal__backdrop').addEventListener('click', () => this.close());
      el.querySelector('.hm-modal__close').addEventListener('click', () => this.close());
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !this.el.hasAttribute('hidden')) this.close();
      });
    }

    open() {
      if (this.busy) return;
      this.el.removeAttribute('hidden');
      this.el.setAttribute('open', '');
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(() => requestAnimationFrame(() => {
        this.el.classList.add('is-open');
      }));
    }

    close() {
      if (this.busy) return;
      this.busy = true;
      this.el.classList.remove('is-open');
      this.panel.addEventListener('transitionend', () => {
        this.el.setAttribute('hidden', '');
        this.el.removeAttribute('open');
        document.documentElement.style.overflow = '';
        this.busy = false;
      }, { once: true });
    }
  }

  function getModal(id) {
    if (registry.has(id)) return registry.get(id);
    const el = document.getElementById(id);
    if (!el) return null;
    const instance = new HmModal(el);
    registry.set(id, instance);
    return instance;
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-opens-modal]');
    if (!trigger) return;
    getModal(trigger.dataset.opensModal)?.open();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const trigger = e.target.closest('[data-opens-modal]');
    if (!trigger) return;
    e.preventDefault();
    getModal(trigger.dataset.opensModal)?.open();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
